<div class="ir-line ir-plugin-validation" *ngIf="showValidations">
  <table class="ir-plugin-table">
    <tr class="th-plugin-line--content ir-plugin-gray">
      <td class="th-plugin-line--data">
        <div *ngFor="let message of messages">
          <span innerHtml="{{ message | translate : { value: plugin } }}"></span>
        </div>
      </td>
    </tr>
  </table>
</div>
